export default __webpack_public_path__ + "static/media/unknownAvatar.91581aeb.svg";